<template>
  <div>
    <v-container fluid>
      <!-- Header -->
      <div class="d-flex align-center justify-space-between mb-4">
        <div>
          <h1 class="text-h4 font-weight-bold mb-1">權限管理</h1>
        </div>
        <div class="ms-auto my-auto mt-lg-0 mt-4">
          <div class="ms-auto my-auto">
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              @click="updatePermissions"
            >
              更新權限
            </v-btn>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pb-0">
        <role-permissions ref="rolePermissions"></role-permissions>
      </div>
    </v-container>
  </div>
</template>

<script>
import RolePermissions from "./RolePermissions.vue";

export default {
  name: "RoleManagement",
  components: {
    RolePermissions,
  },
  methods: {
    updatePermissions() {
      // Call the applyChanges method in the RolePermissions component
      this.$refs.rolePermissions.applyChanges();
    },
  },
};
</script>
